var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-query-sort-area", {
        attrs: {
          config: _vm.queryConfig,
          queryKey: _vm.queryKey,
          queryHandler: _vm.queryHandler
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "tableList",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.bizUnionTypeList,
                border: "",
                "highlight-current-row": ""
              },
              on: { "current-change": _vm.handleSelectionChange }
            },
            [
              _c("el-table-column", {
                attrs: { width: "55" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "copy-radio",
                            class: { circle: _vm.hashCheckedRow(rows.row) }
                          },
                          [_c("div", { staticClass: "circle-dot" })]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "code",
                  label: "CODE",
                  width: "100",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "类型名称",
                  width: "150",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "供应商参与", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.vendorAllowed
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("是")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "服务商参与", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.servicerAllowed
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("是")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "零售商参与", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        rows.row.retailerAllowed
                          ? _c("span", { staticClass: "font-green" }, [
                              _vm._v("是")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "desc",
                  label: "描述",
                  align: "left",
                  "show-overflow-tooltip": ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bdb8591", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdb8591","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizUnion/BizUnionTypeForSelect.vue
// module id = 2470
// module chunks = 0